/**
 * Action Type IDs look like {metaId}-{definitionId}
 * For example: 0-17 or 1-24409694
 */
export const getDefinitionIdFromActionTypeId = actionTypeId => {
  const [__metaId, definitionId] = actionTypeId.split('-');
  return Number.parseInt(definitionId, 10);
};